import { render, staticRenderFns } from "./Menulist.vue?vue&type=template&id=cc0b5ffc"
import script from "./Menulist.vue?vue&type=script&lang=js"
export * from "./Menulist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports